import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Home, SlidersHorizontal, Search, BookOpen, Gift, TrendingUp, GitCompare } from 'lucide-react';
import { PRODUCT_CATEGORIES } from './headerConstants';
import { getPrimaryNav } from '../../../config/navigation';

const ICONS = {
  home: Home,
  categories: SlidersHorizontal,
  'find-products': Search,
  'buying-guides': BookOpen,
  deals: Gift,
  trending: TrendingUp,
  compare: GitCompare,
};

export function MobileMenu({ isOpen, onLinkClick }) {
  const [openSection, setOpenSection] = useState(null);

  if (!isOpen) return null;

  const linkClass = 'flex items-center gap-2 text-slate-700 dark:text-slate-200';

  return (
    <div className="max-h-[80vh] overflow-y-auto lg:hidden border-t border-slate-200 dark:border-slate-700 py-4 px-4 space-y-4">
      {getPrimaryNav().map((item) => {
        const Icon = ICONS[item.key];
        if (item.menu === 'categories') {
          return (
            <div key={item.key}>
              <button
                onClick={() => setOpenSection(openSection === 'categories' ? null : 'categories')}
                className="flex items-center justify-between w-full text-left text-slate-700 dark:text-slate-200"
              >
                <span className="flex items-center gap-2"><Icon className="w-5 h-5" /> {item.label}</span>
                <ChevronDown className={`w-4 h-4 transform transition-transform ${openSection === 'categories' ? 'rotate-180' : ''}`} />
              </button>
              {openSection === 'categories' && (
                <div className="ml-6 mt-2 space-y-4">
                  {PRODUCT_CATEGORIES.mainCategories.map((cat) => (
                    <div key={cat.slug}>
                      <Link to={cat.slug} onClick={onLinkClick} className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-200">
                        <cat.icon className="w-4 h-4" /> {cat.name}
                      </Link>
                      {cat.tags.length > 0 && (
                        <ul className="ml-4 mt-1 space-y-1">
                          {cat.tags.map((tag) => (
                            <li key={tag.slug}>
                              <Link to={tag.slug} onClick={onLinkClick} className="text-xs text-slate-600 dark:text-slate-400">{tag.name}</Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        }
        return (
          <Link key={item.key} to={item.to} onClick={onLinkClick} className={linkClass}>
            <Icon className="w-5 h-5" /> {item.label}
          </Link>
        );
      })}
    </div>
  );
}
